// extracted by mini-css-extract-plugin
export default {"wrapper":"textarea_wrapper__UvRfM","input":"textarea_input__mBtFK"};